module.exports = __webpack_public_path__ + "img/WechatIMG1225.5b0803a4.png";